var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1959_47246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1959_47246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 19.9999C2.85167 19.9999 2.57847 19.8868 2.34708 19.6607C2.11569 19.4348 2 19.1589 2 18.8332C2 18.5182 2.11569 18.245 2.34708 18.0136C2.57847 17.7823 2.85167 17.6666 3.16667 17.6666H16.8333C17.1483 17.6666 17.4215 17.7796 17.6529 18.0057C17.8843 18.2317 18 18.5075 18 18.8332C18 19.1482 17.8843 19.4214 17.6529 19.6528C17.4215 19.8842 17.1483 19.9999 16.8333 19.9999H3.16667ZM5.5 13.1891H6.29L12.9358 6.52718L12.5546 6.10885L12.1619 5.75302L5.5 12.3988V13.1891ZM4.83333 13.2643V12.3588C4.83333 12.2691 4.84618 12.1925 4.87188 12.1288C4.89743 12.0652 4.93958 12.0041 4.99833 11.9453L13.2244 3.71947C13.313 3.63072 13.3984 3.57301 13.4806 3.54635C13.5627 3.51968 13.6433 3.50635 13.7225 3.50635C13.8124 3.50635 13.8915 3.51968 13.96 3.54635C14.0283 3.57301 14.1022 3.62496 14.1817 3.70218L14.9535 4.46135C15.0315 4.5501 15.0865 4.63135 15.1185 4.7051C15.1506 4.77871 15.1667 4.86204 15.1667 4.9551C15.1667 5.03565 15.151 5.11843 15.1196 5.20343C15.0883 5.28843 15.0351 5.3685 14.96 5.44364L6.7275 13.6745C6.66875 13.7334 6.60764 13.7783 6.54417 13.8093C6.48056 13.8402 6.40389 13.8557 6.31417 13.8557H5.42479C5.25451 13.8557 5.11333 13.7997 5.00125 13.6876C4.88931 13.5757 4.83333 13.4345 4.83333 13.2643ZM12.9358 6.52718L12.5546 6.10885L12.1619 5.75302L12.9358 6.52718Z",
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-edit.775c77fc53fbd8ea08298e368b277831.svg";
export { ForwardRef as ReactComponent };